export enum GoogleErrorMessages {
  OVER_QUERY_LIMIT = 'overQueryLimit',
  REQUEST_DENIED = 'requestDenied',
  UNKNOWN_ERROR = 'unknownError',
  ZERO_RESULTS = 'zeroResults',
  INVALID_REQUEST = 'invalidRequest',
  NOT_FOUND = 'notFound',
  OK = 'ok',
  ERROR = 'error',
  MAX_WAYPOINTS_EXCEEDED = 'maxWaypointsExceeded',
  NotLoadingAPIFromGoogleMapsError = 'notLoadingAPIFromGoogleMapsError',
  TOSViolationMapError = 'tOSViolationMapError',
  UnauthorizedURLForClientIdMapError = 'unauthorizedURLForClientIdMapError',
  ApiNotActivatedMapError = 'apiNotActivatedMapError',
  ApiTargetBlockedMapError = 'apiTargetBlockedMapError',
  DeletedApiProjectMapError = 'deletedApiProjectMapError',
  BillingNotEnabledMapError = 'billingNotEnabledMapError',
  ExpiredKeyMapError = 'expiredKeyMapError',
  InvalidClientIdMapError = 'invalidClientIdMapError',
  InvalidKeyMapError = 'invalidKeyMapError',
  MalformedCredentialsMapError = 'malformedCredentialsMapError',
  MissingKeyMapError = 'missingKeyMapError',
  ProjectDeniedMapError = 'projectDeniedMapError',
  RefererDeniedMapError = 'refererDeniedMapError',
  RefererNotAllowedMapError = 'refererNotAllowedMapError',
  OverQuotaMapError = 'overQuotaMapError',
  ApiProjectMapError = 'apiProjectMapError',
  ClientIdLooksLikeCryptoKey = 'clientIdLooksLikeCryptoKey',
  ClientIdLooksLikeKey = 'clientIdLooksLikeKey',
  InvalidChannel = 'invalidChannel',
  InvalidClientId = 'invalidClientId',
  InvalidKey = 'invalidKey',
  InvalidVersion = 'invalidVersion',
  KeyLooksLikeClientId = 'keyLooksLikeClientId',
  KeyLooksLikeCryptoKey = 'keyLooksLikeCryptoKey',
  KeyLooksLikeProjectNumber = 'keyLooksLikeProjectNumber',
  NoApiKeys = 'noApiKeys',
  RetiredVersion = 'retiredVersion',
  SensorNotRequired = 'sensorNotRequired',
  SignatureNotRequired = 'signatureNotRequired',
  SignedInNotSupported = 'signedInNotSupported',
  UrlAuthenticationCommonError = 'urlAuthenticationCommonError',
}
